/* NukkadTales — Ask Gul drawer host (all pages)
   Defines openAg / closeAg / agtMode globally.
   Loaded on every page that has the ag-overlay drawer.
*/
(function () {
  'use strict';

  function modeData() {
    const el = document.getElementById('agModes');
    if (!el) return null;
    const d = el.dataset;
    const split = s => (s || '').split(',').map(x => x.trim()).filter(Boolean);
    return {
      gift:  { prefix: d.giftPrefix || 'A gift for', ph: d.giftPh || '',  pills: split(d.giftPills) },
      decor: { prefix: d.decorPrefix || 'For my',    ph: d.decorPh || '', pills: split(d.decorPills) },
      self:  { prefix: '',                           ph: d.selfPh || '',  pills: split(d.selfPills) }
    };
  }

  function activeIntent() {
    const el = document.querySelector('.agt-tile.on, .m-tile.on');
    if (el) {
      const m = (el.getAttribute('onclick') || '').match(/'(\w+)'/);
      if (m) return m[1];
    }
    return 'gift';
  }

  let _agScrollY = 0;

  window.openAg = function (intent, qOverride) {
    const ov = document.getElementById('agOverlay');
    if (!ov) return;
    const q = (qOverride != null ? qOverride : (document.getElementById('ci') || {}).value || '').trim();
    const it = intent || activeIntent();
    _agScrollY = window.scrollY || window.pageYOffset || 0;
    /* Re-parent both overlay and sheet to body every open call — guarantees they
       are never inside a Foxify section wrapper that may have CSS transforms
       (which would break position:fixed viewport anchoring). */
    if (ov.parentElement !== document.body) document.body.appendChild(ov);
    var sheet = document.querySelector('.ag-sheet');
    if (sheet && sheet.parentElement !== document.body) document.body.appendChild(sheet);
    ov.classList.add('open');
    document.body.classList.add('ag-open');
    if (sheet) sheet.classList.add('open');
    if (typeof window.ntAgOpen === 'function') window.ntAgOpen(it, q);
  };

  window.closeAg = function () {
    const ov = document.getElementById('agOverlay');
    if (ov) ov.classList.remove('open');
    document.body.classList.remove('ag-open');
    var sheet = document.querySelector('.ag-sheet');
    if (sheet) sheet.classList.remove('open');
    window.scrollTo(0, _agScrollY);
  };

  window.agtMode = window.ntAgtMode = function (k) {
    document.querySelectorAll('.agt-tile, .m-tile').forEach(t => {
      t.classList.toggle('on', (t.getAttribute('onclick') || '').indexOf("'" + k + "'") > -1);
    });
    const MODES = modeData();
    const M = MODES && MODES[k];
    if (!M) return;
    const chip = document.getElementById('agtChip');
    const inp  = document.getElementById('ci');
    if (k === 'self') {
      if (chip) chip.classList.remove('show');
    } else if (chip) {
      chip.textContent = M.prefix;
      chip.classList.add('show');
    }
    if (inp) inp.placeholder = M.ph;
    const pills = document.getElementById('pills');
    if (pills) pills.innerHTML = M.pills.map(p =>
      '<button class="pill" onclick="pillGo(\'' + p.replace(/'/g, '') + '\')">' + p + '</button>'
    ).join('');
  };

  window.pillGo = window.ntPillGo = function (label) {
    const inp = document.getElementById('ci');
    if (inp) { inp.value = label; inp.focus(); }
    if (typeof window.openAg === 'function') window.openAg();
  };

  /* init Gul avatars on non-homepage sections */
  (function initGuls() {
    if (!window.makeGul) { setTimeout(initGuls, 120); return; }
    ['askGulAv', 'unlGulAv', 'barGulEl'].forEach(function(id) {
      try {
        var av = document.getElementById(id);
        if (!av || av._gulInit) return;
        av._gulInit = true;
        var sz = id === 'barGulEl' ? 22 : id === 'unlGulAv' ? 32 : 56;
        var g = window.makeGul(av, sz);
        if (!g) return;
        g.setFace(window.F ? window.F.closed : 0);
        setInterval(function() {
          g.frame(window.F ? window.F.blink : 2);
          setTimeout(function() { g.frame(g.base); }, 150);
        }, 3400 + Math.random() * 1400);
      } catch(e) {}
    });
  })();
})();
